import { render, staticRenderFns } from "./AdminReset.vue?vue&type=template&id=4cb17ca4&scoped=true"
import script from "./AdminReset.vue?vue&type=script&lang=js"
export * from "./AdminReset.vue?vue&type=script&lang=js"
import style0 from "./AdminReset.vue?vue&type=style&index=0&id=4cb17ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb17ca4",
  null
  
)

export default component.exports